// extracted by mini-css-extract-plugin
export default {"searchPopup":"HPJhi"};